module.exports = __webpack_public_path__ + "img/bus-passengers.1958f404.jpg";